import { evt_User3DInteraction } from './constants/custom-event-names';
import { dispatchCustomEvent } from '../common/dispatchCustomEvent';
import {
  evt_MouseDown,
  evt_MouseMove,
  evt_MouseUp,
} from './constants/event-names';
import { id_v3dContainer } from './constants/html-ids';

export const listenToUserEventsInsideV3dContainer = () => {
  if (!document) {
    console.warn('Document is undefined');
    return;
  }
  const v3dContainer = document.getElementById(id_v3dContainer);
  if (!v3dContainer) {
    console.warn('V3d container is undefined');
    return;
  }
  let mouseDown = false;
  v3dContainer.addEventListener(evt_MouseDown, () => (mouseDown = true));
  v3dContainer.addEventListener(evt_MouseUp, () => (mouseDown = false));
  v3dContainer.addEventListener(evt_MouseMove, () => {
    if (mouseDown) {
      dispatchCustomEvent(evt_User3DInteraction);
    }
  });
};
